<template>
  <div class="coin">
    <XR-head titleText="我的配货额" :rightShow="true"></XR-head>
    <div class="total" v-if="!loaded" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="title">配货额</p>
      <p class="money">{{memberFinance.Coin.toFixed(2)}}</p>
    </div>
    <div class="sub-nav" v-if="!loaded">
      <mu-list>
        <router-link to="/salesman/purchasecoinStream">
          <mu-list-item title="交易查询">
            <mu-icon slot="left" value=":fa fa-money"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
      </mu-list>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
import {ErrorCode} from '../../util/errorcode'
export default {
  data() {
    return {
      loaded : true,
      memberFinance :{
        Coin:0
      },
      siteConfig:{ MobileBgImage : '' }
    };
  },
  mounted :function(){
    this.$refs.XRtoast.load()
    this.$refs.XRPageTip.initTip()
    this.getSiteInfo()
    this.getFinanceInfo()
  },
  methods: {
    getSiteInfo: function () {    
        const ths = this;
        this.$post('/Shop/SiteConfigServer/GetSiteConfig')
            .then(function (res) {
            if(res.IsSuccess){
                ths.siteConfig = res.Data
            }         
        })
        .catch(function (err) {
            console.log(err)
        })    
    },      
    getFinanceInfo: function() {
      var ths = this;   
      ths.$post(
        "/Salesman/PurchaseServer/GetPurchaseCoinAccount"
      ).then(function(res) {
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
          ths.$refs.XRPageTip.ShowEmpty(res.Msg)
        }else{          
          ths.memberFinance = res.Data;
          ths.loaded = false
        }
      });
    }
  }
};
</script>
<style>
.coin .total{
  padding: 20px 20px;
  overflow: hidden;
  background: url(/static/us-top-bg.png);
  background-size: 100% 100%;
}
.coin .title{
  line-height: 24px;
  font-size: 14px;
  color: white;
}
.coin .money{
  font-size: 46px;
  color:red;
  line-height: 42px;
  padding: 10px 0 10px;
  letter-spacing: -1px;
  color: white;
}
.coin .sub-nav{
  background: white;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesman/purchasecoin.vue